import Vacantest from './src/Vacantest';

export default Vacantest;
